import type { ReactNode } from "react"

import { CarouselInnerUl, CarouselSlideLi } from "./styled"

export interface CarouselSlidesProps {
  readonly children: ReactNode[]
  readonly columnGap: number
  readonly id: string
  readonly name?: string
  readonly slidesToShow: number
  readonly translateX: number
  readonly translateXOffset: number
}

const CarouselSlides = ({
  children,
  columnGap,
  id,
  name,
  slidesToShow,
  translateX,
  translateXOffset
}: CarouselSlidesProps) => (
  <CarouselInnerUl
    $columnGap={columnGap}
    $slidesToShow={slidesToShow}
    $translateX={translateX}
    $translateXOffset={translateXOffset}
    aria-label={name ? `${name} Carousel List` : "Carousel List"}
  >
    {children.map((child, index) => (
      <CarouselSlideLi
        $slidesToShow={slidesToShow}
        aria-label={
          name
            ? `${name} Carousel List Item ${index}`
            : `Carousel List Item ${index}`
        }
        // eslint-disable-next-line react/no-array-index-key
        key={`${id}-${index}`}
      >
        {child}
      </CarouselSlideLi>
    ))}
  </CarouselInnerUl>
)

export default CarouselSlides
